
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/blog/category/[categoryUid]",
      function () {
        return require("private-next-pages/blog/category/[categoryUid].js");
      }
    ]);
  